import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API_ORIGIN } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const tries = useRef(0);

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let stop = false;
    const poll = async () => {
      if (stop || tries.current >= 8) { if (!stop) setState("timeout"); return; }
      tries.current += 1;
      try {
        const { data } = await axios.get(`${API_ORIGIN}/api/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setState("failed"); return; }
      } catch { /* keep polling */ }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { stop = true; };
  }, [sessionId]);

  const messages = {
    checking: "Confirming your payment with Stripe...",
    paid: "Payment confirmed. Your plan is now active.",
    failed: "The payment did not complete. No charge was made.",
    timeout: "Payment is still processing. Check the billing page in a minute.",
    error: "Missing payment session.",
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center px-6">
      <div className="bg-white border border-gray-200 rounded-sm p-8 max-w-md w-full" data-testid="payment-success-page">
        <h1 className="font-heading text-xl font-bold text-[#16324F] mb-2">
          {state === "paid" ? "Subscription active" : "Payment status"}
        </h1>
        <p className={`text-sm mb-6 ${state === "paid" ? "text-[#2E7D32]" : state === "failed" ? "text-[#C62828]" : "text-ink-muted"}`} role="status" data-testid="payment-status-message">
          {messages[state]}
        </p>
        <Link to="/billing" data-testid="back-to-billing-link"
          className="inline-block bg-[#16324F] text-white rounded-sm px-4 py-2 text-sm hover:bg-[#10243a] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#16324F] focus-visible:ring-offset-2">
          Back to billing
        </Link>
      </div>
    </div>
  );
}
